<ol class="flex flex-col gap-4" data-cy="agent-messages">
  @for (message of messages(); track $index) {
    @if (message.role === 'user') {
      <li class="flex flex-col items-end gap-1" data-cy="agent-message" data-role="user">
        <span class="text-xs text-gray-500">
          {{ (viewer() === 'admin' ? 'agent-chat.merchant' : 'agent-chat.you') | translate }}
        </span>
        <p
          class="max-w-[85%] whitespace-pre-wrap break-words rounded-2xl rounded-br-sm bg-brand-600 px-3 py-2 text-white"
        >
          {{ message.content }}
        </p>
      </li>
    } @else {
      <li class="flex flex-col items-start gap-1" data-cy="agent-message" [attr.data-role]="message.role">
        <span class="text-xs text-gray-500">
          {{ (message.role === 'admin' ? 'agent-chat.team' : 'agent-chat.assistant') | translate }}
        </span>
        <div
          class="max-w-[90%] rounded-2xl rounded-bl-sm px-3 py-2"
          [class]="message.role === 'admin' ? 'border border-brand-600 bg-brand-100' : 'bg-gray-100'"
        >
          <app-markdown [markdown]="message.content" />
        </div>
        @if (message.tools?.includes('read_article')) {
          <span class="text-xs text-gray-500" data-cy="agent-used-articles">{{
            'agent-chat.used-articles' | translate
          }}</span>
        }

        @if (message.role === 'assistant' && message._id) {
          @if (viewer() === 'merchant') {
            <div class="flex items-center gap-1" data-cy="agent-feedback">
              <button
                mat-icon-button
                type="button"
                class="!h-8 !w-8 !p-1"
                [class.text-brand-600]="message.feedback?.rating === 'up'"
                [attr.aria-pressed]="message.feedback?.rating === 'up'"
                [attr.aria-label]="'agent-chat.feedback.helpful' | translate"
                (click)="rate(message._id, 'up')"
                data-cy="agent-feedback-up"
              >
                <mat-icon [class.material-icons-outlined]="message.feedback?.rating !== 'up'">thumb_up</mat-icon>
              </button>
              <button
                mat-icon-button
                type="button"
                class="!h-8 !w-8 !p-1"
                [class.text-brand-600]="message.feedback?.rating === 'down'"
                [attr.aria-pressed]="message.feedback?.rating === 'down'"
                [attr.aria-label]="'agent-chat.feedback.not-helpful' | translate"
                (click)="rate(message._id, 'down')"
                data-cy="agent-feedback-down"
              >
                <mat-icon [class.material-icons-outlined]="message.feedback?.rating !== 'down'">thumb_down</mat-icon>
              </button>
              @if (message.feedback && commenting() !== message._id) {
                <span class="text-xs text-gray-500" data-cy="agent-feedback-thanks">{{
                  'agent-chat.feedback.thanks' | translate
                }}</span>
              }
            </div>

            @if (commenting() === message._id) {
              <form
                class="flex w-full max-w-[90%] flex-col gap-2"
                (ngSubmit)="sendComment(message._id)"
                data-cy="agent-feedback-comment"
              >
                <textarea
                  class="min-h-[60px] resize-none rounded-xl border border-gray-200 px-3 py-2 text-sm outline-none focus:border-brand-600"
                  name="comment"
                  [maxlength]="commentMaxLength"
                  [ngModel]="comment()"
                  (ngModelChange)="comment.set($event)"
                  [placeholder]="'agent-chat.feedback.comment-placeholder' | translate"
                  [attr.aria-label]="'agent-chat.feedback.comment-placeholder' | translate"
                  data-cy="agent-feedback-comment-input"
                ></textarea>
                <div class="flex justify-end gap-2">
                  <button mat-button type="button" (click)="commenting.set(null)" data-cy="agent-feedback-skip">
                    {{ 'agent-chat.feedback.skip' | translate }}
                  </button>
                  <button mat-stroked-button type="submit" [disabled]="!comment().trim()" data-cy="agent-feedback-send">
                    {{ 'agent-chat.feedback.send' | translate }}
                  </button>
                </div>
              </form>
            }
          } @else if (message.feedback) {
            <p class="max-w-[90%] text-xs text-gray-500" data-cy="agent-feedback-readonly">
              {{
                (message.feedback.rating === 'up' ? 'agent-chat.feedback.rated-up' : 'agent-chat.feedback.rated-down')
                  | translate
              }}
              @if (message.feedback.comment) {
                <span class="whitespace-pre-wrap break-words">: “{{ message.feedback.comment }}”</span>
              }
            </p>
          }
        }
      </li>
    }
  }

  @if (pending(); as reply) {
    <li class="flex flex-col items-start gap-1" data-cy="agent-pending">
      <span class="text-xs text-gray-500">{{ 'agent-chat.assistant' | translate }}</span>
      @if (reply.text) {
        <div class="max-w-[90%] rounded-2xl rounded-bl-sm bg-gray-100 px-3 py-2">
          <app-markdown [markdown]="reply.text" />
        </div>
      } @else {
        <p
          class="rounded-2xl rounded-bl-sm bg-gray-100 px-3 py-2 text-sm italic text-gray-600"
          data-cy="agent-activity"
        >
          {{ (reply.activity ? 'agent-chat.activity.' + reply.activity : 'agent-chat.typing') | translate }}
        </p>
      }
    </li>
  }
</ol>
